import { render, staticRenderFns } from "./MeusHorariosPage.vue?vue&type=template&id=1fc640bc&scoped=true"
import script from "./MeusHorariosPage.vue?vue&type=script&lang=js"
export * from "./MeusHorariosPage.vue?vue&type=script&lang=js"
import style0 from "./MeusHorariosPage.vue?vue&type=style&index=0&id=1fc640bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc640bc",
  null
  
)

export default component.exports